<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="close" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalShipmentDetailEditVisible" vm-title='Edit Detail' :vm-is-valid="!$v.detail.$invalid")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        dual-input(:data="detail.shipment_remaining" :item="detail" :idx="index" @input="setShipped" :disabledLeft="parseInt(detail.shipment_complete_total.split('/')[0]) >= parseInt(detail.shipment_complete_total.split('/')[1]) || detail.shipment_complete" :disabledRight="true" :resetVal="reset" @reset="doReset")
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalShipmentDetailEdit',
  components: {
    DualInput: () => import('@/components/aditionals/DualInput.vue')
  },
  props: {
    detail: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  validations: {
    detail: {
    }
  },
  data: () => ({
    form: {}
  }),
  computed: {
    ...mapGetters([
      'isModalShipmentDetailEditVisible'
    ])
  },
  methods: {
    ...mapActions([
      'setModalShipmentDetailEditVisible'
    ]),
    saveRecord () {
    },
    close () {
      this.setModalShipmentDetailEditVisible(false)
    },
    setShipped (data) {
      if (data.val > 0 && data.val <= parseInt(data.limit) - parseInt(data.oldVal)) {
        this.form = data
        this.isInvalid = false
      }
    }
  }
}
</script>
